import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/k67lc1vz_image.png',
      title: 'We Welcome All German Car Brands',
      subtitle: 'Audi • BMW • Mercedes-Benz • Porsche • Volkswagen',
      cta: 'Book Now',
      link: '#contact'
    },
    {
      id: 2,
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/x5tfan3j_image.png',
      title: 'Porsche Specialists',
      subtitle: 'We Specialize in All Porsche Models. Contact Us for Expert Assistance',
      cta: 'Our Services',
      link: '#services'
    },
    {
      id: 3,
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/mqlgvy3k_image.png',
      title: 'Servicing All Mercedes-Benz Models',
      subtitle: 'From A-Class to AMG & G-Class — Expert Diagnostics, Genuine Parts & Dealer-Level Care in Dubai.',
      cta: 'Contact Us',
      link: '#contact'
    },
    {
      id: 4,
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/0re9qlx9_image.png',
      title: 'Specialists in Italian Super Sports Cars',
      subtitle: 'Need expert assistance with your Italian super sports car? Contact us today.',
      cta: 'View Services',
      link: '#services'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  // Auto advance slides
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="relative w-full h-[500px] sm:h-[600px] md:h-[700px] lg:h-[600px] overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ 
              backgroundImage: `url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center center'
            }}
          >
            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
          </div>

          {/* Content */}
          <div className="relative z-20 container mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
            <div className="max-w-3xl">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 animate-fadeIn">
                {slide.title}
              </h2>
              <p className="text-lg sm:text-xl md:text-2xl text-gray-200 mb-8 animate-fadeIn animation-delay-200">
                {slide.subtitle}
              </p>
              <a
                href={slide.link}
                className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-red-600/50 animate-fadeIn animation-delay-400"
              >
                {slide.cta}
              </a>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows - Hidden on mobile, visible on desktop */}
      <button
        onClick={prevSlide}
        className="hidden md:block absolute left-4 top-1/2 -translate-y-1/2 z-30 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-200"
        aria-label="Previous slide"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>
      <button
        onClick={nextSlide}
        className="hidden md:block absolute right-4 top-1/2 -translate-y-1/2 z-30 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-200"
        aria-label="Next slide"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide
                ? 'bg-red-600 w-8'
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
